import { appSettings } from '@/settings/app-settings';

import createHttpClient from './http-client';

const httpClient = createHttpClient(appSettings.api.ASSET_MANAGER_URL || '');

export async function vendorConnectRequest(vendorId: string) {
  try {
    const response = await httpClient.get(`/vendor-connect/list-received-request/${vendorId}`);

    return response.data;
  } catch (error: any) {
    console.log('>>> error list received request', error.message);
    throw error;
  }
}

export async function vendorConnectSentRequest(vendorId: string) {
  try {
    const response = await httpClient.get(`/vendor-connect/list-sent-request/${vendorId}`);

    return response.data;
  } catch (error: any) {
    console.log('>>> error list sent request', error.message);
    throw error;
  }
}

export async function vendorConnectionResponse(id: string, payload: any) {
  try {
    const response = await httpClient.put(`/vendor-connect/handle-connect/${id}`, payload);

    return response.data;
  } catch (error: any) {
    console.log('>>> error list sent request', error.message);
    throw error;
  }
}

export async function vendorConnectionRequest(payload: any) {
  try {
    const response = await httpClient.post(`/vendor-connect/request`, payload);

    return response.data;
  } catch (error: any) {
    console.log('>>> error list sent request', error.message);
    throw error;
  }
}

export async function vendorConnectedPartners(vendorId: string) {
  try {
    const response = await httpClient.get(`/vendor-connect/list-connected/${vendorId}`);

    return response.data;
  } catch (error: any) {
    console.log('>>> error list sent request', error.message);
    throw error;
  }
}

export async function vendordisConnectedPartners(payload: any) {
  try {
    const response = await httpClient.put(`/vendor-connect/handle-disconnect`, payload);
    return response.data;
  } catch (error: any) {
    console.log('>>> error list sent request', error.message);
    throw error;
  }
}

export async function ConnectedPartnersAsset(
  vendorId: string,
  limit: number,
  offset: number,
  type: string,
  belongTo: string,
) {
  try {
    const response = await httpClient.get(
      `/vendor-share/connected-assets/${vendorId}?limit=${limit}&offset=${offset}&type=${type}&belongTo=${belongTo}`,
    );
    return response.data;
  } catch (error: any) {
    console.log('>>> error list sent request', error.message);
    throw error;
  }
}

export async function createVendorShareAsset(payload: any) {
  try {
    const response = await httpClient.post(`/vendor-share/create`, payload);
    return response.data;
  } catch (error: any) {
    console.log('>>> error list sent request', error.message);
    throw error;
  }
}

export async function updateVendorShareAsset(id: string, revenue: number, status: string) {
  try {
    const response = await httpClient.put(`/vendor-share/update/${id}?revenue=${revenue}&status=${status}`);
    return response.data;
  } catch (error: any) {
    console.log('>>> error list sent request', error.message);
    throw error;
  }
}

export async function partnerRevenueShare(
  vendorId: string,
  limit: number,
  offset: number,
  startDate?: string,
  endDate?: string,
) {
  try {
    let url = '/asset-vendor/getVendorSharesByOrder';
    url = url + (vendorId ? `?vendorId=${vendorId}` : '');
    url = url + (limit || limit == 0 ? `&limit=${limit}` : '');
    url = url + (offset || offset == 0 ? `&offset=${offset}` : '');
    url = url + (startDate != undefined ? `&startDate=${startDate}` : '');
    url = url + (endDate != undefined ? `&endDate=${endDate}` : '');
    url = url + `&status=CONFIRMED`;
    const response = await httpClient.get(url);
    return response.data;
  } catch (error: any) {
    console.log('Error while getting partnerRevenueShare', error.message);
    throw error;
  }
}

export async function partnerRevenueReceive(
  vendorId: string,
  limit: number,
  offset: number,
  startDate?: string,
  endDate?: string,
) {
  try {
    let url = '/asset-vendor/getVendorSharesDetails';
    url = url + (vendorId ? `?vendorId=${vendorId}` : '');
    url = url + (limit || limit == 0 ? `&limit=${limit}` : '');
    url = url + (offset || offset == 0 ? `&offset=${offset}` : '');
    url = url + (startDate != undefined ? `&startDate=${startDate}` : '');
    url = url + (endDate != undefined ? `&endDate=${endDate}` : '');
    url = url + `&status=CONFIRMED`;
    const response = await httpClient.get(url);
    return response.data;
  } catch (error: any) {
    console.log('Error while getting partnerRevenueShare', error.message);
    throw error;
  }
}

export async function getUserRevenueShare(
  type: string,
  limit: number,
  offset: number,
  startDate?: string,
  endDate?: string,
) {
  try {
    let url = '/asset-vendor/getUserRevenueShare';
    url = url + (limit || limit == 0 ? `?type=${type}` : '');
    url = url + (limit || limit == 0 ? `&limit=${limit}` : '');
    url = url + (offset || offset == 0 ? `&offset=${offset}` : '');
    url = url + (startDate != undefined ? `&startDate=${startDate}` : '');
    url = url + (endDate != undefined ? `&endDate=${endDate}` : '');
    url = url + `&status=CONFIRMED`;
    const response = await httpClient.get(url);
    return response.data;
  } catch (error: any) {
    console.log('Error while getting partnerRevenueShare', error.message);
    throw error;
  }
}

export async function getUserConnectedAssets(params: { limit: number; offset: number; search: string }) {
  try {
    const response = await httpClient.get('/vendor-share/user-connected-assets', { params });
    return response.data;
  } catch (error) {
    console.log('>>> Error while getting user connected assets', error);
    throw error;
  }
}

export async function getVendorConnectedAssetsById(
  vendorId: string,
  params: {
    limit: number;
    offset: number;
    search: string;
    type: 'to' | 'from';
  },
) {
  try {
    const response = await httpClient.get(`/vendor-share/connected-assets/${vendorId}`, { params });
    return response.data;
  } catch (error) {
    console.log('>>> Error while getting vendor connects assets', error);
    throw error;
  }
}

export async function getUserRevenueReceive(limit: number, offset: number) {
  try {
    let url = '/vendor-share/user-connected-assets';
    url = url + (limit || limit == 0 ? `?limit=${limit}` : '');
    url = url + (offset || offset == 0 ? `&offset=${offset}` : '');
    const response = await httpClient.get(url);
    return response.data;
  } catch (error: any) {
    console.log('Error while getting partnerRevenueShare', error.message);
    throw error;
  }
}

export async function createUserAssetRevenue(payload: any) {
  try {
    const response = await httpClient.post(`/vendor-share/create-user-asset-revenue`, payload);
    return response.data;
  } catch (error: any) {
    console.log('>>> error list sent request', error.message);
    throw error;
  }
}

export async function getAffiliateLinkUsage(payload: any) {
  try {
    const response = await httpClient.get(`/share-link/get-affiliate-link-usage`, { params: payload });
    return response.data;
  } catch (error: any) {
    console.log('>>> error list sent request', error.message);
    throw error;
  }
}

export async function getAffiliateLinkUsageOfUser(payload: any) {
  try {
    const response = await httpClient.get(`/share-link/get-affiliate-link-usage-of-user`, {
      params: payload,
    });
    return response.data;
  } catch (error: any) {
    console.log('>>> error list sent request', error.message);
    throw error;
  }
}
